<template>
  <div class="home">
    <h1>Welcome</h1>
  </div>
</template>
